import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule, FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Constants } from '../../../constants/constants';
import { Subject, Subscription, startWith, takeUntil } from 'rxjs';
import { ReviewService } from '../../../services/review.service';
import { CommonDataService } from '../../../services/common-data.service';
import { SiFormFieldComponent } from '../../Si-Web-Toolkit/si-form-field/si-form-field.component';
import { SiDropDownComponent } from '../../Si-Web-Toolkit/si-drop-down/si-drop-down.component';
import { SiCheckBoxComponent } from '../../Si-Web-Toolkit/si-check-box/si-check-box.component';
import { SiCheckBoxGroupComponent } from '../../Si-Web-Toolkit/si-check-box-group/si-check-box-group.component';
import { SiRadioButtonComponent } from '../../Si-Web-Toolkit/si-radio-button/si-radio-button.component';
import { IPreFabControllerForm } from '../../../models/SolChecklistInterfaces/IPreFabControllerForm';
import { IBuildingLevelNetworkPanelsForm } from '../../../models/SolChecklistInterfaces/IBuildingLevelNetworkPanelsForm';
import { ISystemAttributesForm } from '../../../models/SolChecklistInterfaces/ISystemAttributesForm';
import { ISystemConfigurationForm } from '../../../models/SolChecklistInterfaces/ISystemConfigurationForm';
import { IRetrofitConsiderationsForm } from '../../../models/SolChecklistInterfaces/IRetrofitConsiderationsForm';
import { IOperatorWorkstationForm } from '../../../models/SolChecklistInterfaces/IOperatorWorkstationForm';
import { IChillerPlantForm } from '../../../models/SolChecklistInterfaces/IChillerPlantForm';
import { IHeatingPlantForm } from '../../../models/SolChecklistInterfaces/IHeatingPlantForm';
import { IFlnForm } from '../../../models/SolChecklistInterfaces/IFlnForm';
import { ITerminalControllersForm } from '../../../models/SolChecklistInterfaces/ITerminalControllersForm';
import { ILabEquipmentForm } from '../../../models/SolChecklistInterfaces/ILabEquipmentForm';
import { IVfdsForm } from '../../../models/SolChecklistInterfaces/IVfdsForm';
import { IControlValvesForm } from '../../../models/SolChecklistInterfaces/IControlValvesForm';
import { IAfmssForm } from '../../../models/SolChecklistInterfaces/IAfmssForm';
import { ActionNeededField } from '../../../models/ActionNeededFieldChange';
import { CostReviewPrefab } from '../../../models/CostReviewPrefab';
import { CostReviewBuildingLevelNetworkPanels } from '../../../models/CostReviewBuildingLevelNetworkPanels';
import { CostReviewFireEnUsSystemAttributes } from '../../../models/CostReviewFireEnUsSystemAttributes';
import { CostReviewAfms } from '../../../models/CostReviewAfms';
import { CostReviewAttributes } from '../../../models/CostReviewAttributes';
import { CostReviewChillerPlant } from '../../../models/CostReviewChillerPlant';
import { CostReviewControlValves } from '../../../models/CostReviewControlValves';
import { CostReviewFireEnUsRetrofitConsiderations } from '../../../models/CostReviewFireEnUsRetrofitConsiderations';
import { CostReviewFireEnUsSystemConfiguration } from '../../../models/CostReviewFireEnUsSystemConfiguration';
import { CostReviewFln } from '../../../models/CostReviewFln';
import { CostReviewHeatingPlant } from '../../../models/CostReviewHeatingPlant';
import { CostReviewLabEquipment } from '../../../models/CostReviewLabEquipment';
import { CostReviewOperatorWorkstationSoftware } from '../../../models/CostReviewOperatorWorkstationSoftware';
import { CostReviewTerminalControllers } from '../../../models/CostReviewTerminalControllers';
import { CostReviewVfds } from '../../../models/CostReviewVfds';
import { CostReviewFireEnUsAttributes } from '../../../models/CostReviewFireEnUsAttributes';
import { TrackChangesDirective } from '../../../Directives/track-changes.directive';

import { SiTextAreaComponent } from '../../Si-Web-Toolkit/si-text-area/si-text-area.component';
import { ReviewDetailTabsService } from '../../../lib/review-detail-tabs.service';
import { CostReviewEstimateType } from '../../../models/enum';
import { CommonFunctionsService } from '../../../services/common-functions.service';
import { SiComboBoxComponent } from '../../Si-Web-Toolkit/si-combo-box/si-combo-box.component';

type BuildingLevelNetworkPanelsFormValue = ReturnType<FormGroup<IBuildingLevelNetworkPanelsForm>['getRawValue']>;
type SystemAttributesFormValue = ReturnType<FormGroup<ISystemAttributesForm>['getRawValue']>;
type SystemConfigurationFormValue = ReturnType<FormGroup<ISystemConfigurationForm>['getRawValue']>;
type RetrofitConsiderationsFormValue = ReturnType<FormGroup<IRetrofitConsiderationsForm>['getRawValue']>;
type OperatorWorkstationFormValue = ReturnType<FormGroup<IOperatorWorkstationForm>['getRawValue']>;
type ChillerPlantFormValue = ReturnType<FormGroup<IChillerPlantForm>['getRawValue']>;
type HeatingPlantFormValue = ReturnType<FormGroup<IHeatingPlantForm>['getRawValue']>;
type FlnFormValue = ReturnType<FormGroup<IFlnForm>['getRawValue']>;
type TerminalControllersFormValue = ReturnType<FormGroup<ITerminalControllersForm>['getRawValue']>;
type LabEquipmentFormValue = ReturnType<FormGroup<ILabEquipmentForm>['getRawValue']>;
type VfdsFormValue = ReturnType<FormGroup<IVfdsForm>['getRawValue']>;
type ControlValvesFormValue = ReturnType<FormGroup<IControlValvesForm>['getRawValue']>;
type AfmssFormValue = ReturnType<FormGroup<IAfmssForm>['getRawValue']>;

@Component({
  selector: 'lib-sol-checklist-part-one',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatLabel,
    MatFormFieldModule,
    MatRadioModule,
    SiFormFieldComponent,
    SiDropDownComponent,
    SiCheckBoxComponent,
    SiCheckBoxGroupComponent,
    SiRadioButtonComponent,
    TrackChangesDirective,
    SiTextAreaComponent,
    SiComboBoxComponent
],
  templateUrl: './sol-checklist-part-one.component.html',
  styleUrl: './sol-checklist-part-one.component.scss'
})
export class SolChecklistPartOneComponent implements OnInit, OnDestroy {

  batteryBackupList: { label: string; value: string }[] = [];
  constants = Constants;
  business = '';
  isSalePriceGreaterThan150 = false;
  isReadOnlyMode = false;
  isDisabled = false;
  optionalWorkflowCondition = false;
  sectionToggleState: Record<string, boolean> = {};
  sectionDisableState: Record<string, boolean> = {};
  childFieldDisabledState: Record<string, boolean> = {};
  reasonsForExceptionDropDownData: Array<{ label: string; value: string }> = [];
  // Checkbox group options arrays
  additionalSystemsOptions = ['MASS_NOTIFICATION_CONTACT_COC_REVIEW', 'DISTRIBUTED_ANTENNA_SYSTEM_DAS', 'AREA_OF_REFUGE', 'NURSE_CALL', 'VOICE_SPEAKERS_CONVENIENCE_PAGING_BACKGROUND_MUSIC', 'SUPPRESSION', 'VESDA'];
  desigoPanelsOptions = ['DESIGO_PANELS_MODULAR', 'DESIGO_PANELS_250', 'DESIGO_PANELS_500'];
  backupAmpsOptions = ['BACKUP_AMPS_ONE_FOR_ONE', 'BACKUP_AMPS_ONE_PER_ENCLOSURE'];
  networkOptionsArray = ['NETWORK_OPTION_FIBER', 'NETWORK_OPTION_COPPER', 'NETWORK_OPTION_STYLE_4', 'NETWORK_OPTION_STYLE_7'];
  operatorProtocolOptions = ['OPERATOR_PROTOCOL_ETHERNET', 'OPERATOR_PROTOCOL_OPC_CLIENT', 'OPERATOR_PROTOCOL_OPC_SERVER', 'OPERATOR_PROTOCOL_BACNET', 'OPERATOR_PROTOCOL_LON'];
  flnNetworkTypeOptions = ['ETHERNET', 'MSTP'];
  terminalControllerTypeOptions = ['TERMINAL_CONTROLLER_TYPE_DXR', 'TERMINAL_CONTROLLER_TYPE_LAB', 'TERMINAL_CONTROLLER_TYPE_TRA', 'OTHER'];
  controlValvesApplicationOptions = ['CONTROL_VALVES_APPLICATION_ANSI', 'CONTROL_VALVES_APPLICATION_PICV', 'CONTROL_VALVES_APPLICATION_CLOSE_OFF', 'CONTROL_VALVES_APPLICATION_VALVE_SCHEDULE'];
  afmssApplicationOptions = ['AFMSS_APPLICATION_TEMP', 'AFMSS_APPLICATION_LOW_VELOCITY'];

  private readonly destroy$ = new Subject<void>();
  private formChangesSubscription?: Subscription;

  /** Read-only view shows a "not applicable" placeholder instead of the form when the optional section is unchecked. */
  get isSystemAttributesNotApplicableReadOnly(): boolean {
    return this.isReadOnlyMode
      && this.optionalWorkflowCondition
      && !this.isSectionChecked('systemAttributesFormGroup');
  }

  isSectionChecked(section: string): boolean {
    return !!this.sectionToggleState[section];
  }

  private readonly childFieldsBySection: Record<string, string[]> = {
    chillerPlantFormGroup: ['numberOfChillers', 'numberOfTowers', 'numberOfPumps'],
    heatingPlantFormGroup: ['numberOfBoilers', 'numberOfTowers', 'numberOfPumps'],
    terminalControllersFormGroup: ['numberOfVavs', 'numberOfFcus', 'numberOfUvs']
  };

  private setupChildFieldDisabledState(): void {
    for (const [section, controlNames] of Object.entries(this.childFieldsBySection)) {
      const formGroup = this[section as keyof this] as FormGroup | undefined;
      if (!formGroup) {
        continue;
      }

      this.updateChildFieldDisabledState(section, formGroup, controlNames);
      formGroup.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.updateChildFieldDisabledState(section, formGroup, controlNames));
    }
  }

  private updateChildFieldDisabledState(section: string, formGroup: FormGroup, controlNames: string[]): void {
    for (const controlName of controlNames) {
      this.childFieldDisabledState[`${section}.${controlName}`] =
        !this.isSectionChecked(section) || this.formControlsValueForNumber(formGroup, controlName) <= 0;
    }
  }

  private isSectionApplicable(section: string): boolean {
    switch (section) {
      case 'preFabControllerFormGroup':
        return !!this.costReviewPreFab?.isPrefabControllerVisible;
      case 'buildingLevelNetworkPanelsFormGroup':
        return !!this.costReviewBuildingLevelNetworkPanels?.isBuildingLevelNetworkPanelsApplicable;
      case 'systemAttributesFormGroup':
        return !this.optionalWorkflowCondition || !!this.costReviewSystemAttributes?.isSystemAttributeApplicable;
      case 'systemConfigurationFormGroup':
        return !this.optionalWorkflowCondition || !!this.costReviewSystemConfiguration?.isSystemConfigurationApplicable;
      case 'retrofitConsiderationsFormGroup':
        return !!this.costReviewRetrofitConsiderations?.isRetrofitConsiderationsApplicable;
      case 'operatorWorkstationFormGroup':
        return !!this.costReviewOperatorWorkstationSoftware?.isOpWorksationsSoftwareApplicable;
      case 'chillerPlantFormGroup':
        return !!this.costReviewChillerPlant?.isChillerPlantApplicable;
      case 'heatingPlantFormGroup':
        return !!this.costReviewHeatingPlant?.isHeatingPlantApplicable;
      case 'flnFormGroup':
        return !!this.isSalePriceGreaterThan150 && !!this.flnFormGroup;
      case 'terminalControllersFormGroup':
        return !!this.costReviewTerminalUnits?.isTerminalControllersApplicable;
      case 'labEquipmentFormGroup':
        return !!this.costReviewLabEquipment?.isLabEquipmentApplicable;
      case 'vfdsFormGroup':
        return !!this.costReviewVFDS?.isVfdsApplicable;
      case 'controlValvesFormGroup':
        return !!this.costReviewControlValves?.isControlValvesApplicable;
      case 'afmssFormGroup':
        return !!this.costReviewAfmss?.isAfmsApplicable;
      default:
        return true;
    }
  }

  private getSectionDisabledState(section: string): boolean {
    return this.isDisabled || !this.isSectionChecked(section);
  }

  private initializeSectionToggleState(): void {
    const sections = [
      'preFabControllerFormGroup',
      'buildingLevelNetworkPanelsFormGroup',
      'systemAttributesFormGroup',
      'systemConfigurationFormGroup',
      'retrofitConsiderationsFormGroup',
      'operatorWorkstationFormGroup',
      'chillerPlantFormGroup',
      'heatingPlantFormGroup',
      'flnFormGroup',
      'terminalControllersFormGroup',
      'labEquipmentFormGroup',
      'vfdsFormGroup',
      'controlValvesFormGroup',
      'afmssFormGroup'
    ];

    for (const section of sections) {
      this.sectionToggleState[section] = this.isSectionApplicable(section);
      this.sectionDisableState[section] = this.getSectionDisabledState(section);
    }
  }

  onSectionToggle(section: string, checked: boolean): void {
    this.sectionToggleState[section] = checked;
    this.sectionDisableState[section] = this.getSectionDisabledState(section);
    const controlNames = this.childFieldsBySection[section];
    const formGroup = this[section as keyof this] as FormGroup | undefined;
    if (controlNames && formGroup) {
      this.updateChildFieldDisabledState(section, formGroup, controlNames);
    }
    this.persistSectionToggleState(section, checked);
    if (section === 'systemConfigurationFormGroup') {
      this.updateSystemConfigurationEditability();
    }
    if (section === 'systemAttributesFormGroup') {
      this.updateSystemAttributesEditability();
    }
  }

  private updateSystemAttributesEditability(): void {
    if (!this.reviewDetailsTabService.getIsLibraryUsedInSQ()
      || this.isReadOnlyMode || this.getSectionDisabledState('systemAttributesFormGroup')) {
      this.systemAttributesFormGroup.disable();
    } else {
      this.systemAttributesFormGroup.enable();
    }
  }

  private updateSystemConfigurationEditability(): void {
    if (!this.reviewDetailsTabService.getIsLibraryUsedInSQ()
      || this.isReadOnlyMode || this.getSectionDisabledState('systemConfigurationFormGroup')) {
      this.systemConfigurationFormGroup.disable();
    } else {
      this.systemConfigurationFormGroup.enable();
    }
  }

  private persistSectionToggleState(section: string, checked: boolean): void {
    switch (section) {
      case 'preFabControllerFormGroup':
        this.costReviewPreFab.isPrefabControllerVisible = checked;
        break;
      case 'buildingLevelNetworkPanelsFormGroup':
        this.costReviewBuildingLevelNetworkPanels.isBuildingLevelNetworkPanelsApplicable = checked;
        break;
      case 'systemAttributesFormGroup':
        this.costReviewSystemAttributes.isSystemAttributeApplicable = checked;
        break;
      case 'systemConfigurationFormGroup':
        this.costReviewSystemConfiguration.isSystemConfigurationApplicable = checked;
        break;
      case 'retrofitConsiderationsFormGroup':
        this.costReviewRetrofitConsiderations.isRetrofitConsiderationsApplicable = checked;
        break;
      case 'operatorWorkstationFormGroup':
        this.costReviewOperatorWorkstationSoftware.isOpWorksationsSoftwareApplicable = checked;
        break;
      case 'chillerPlantFormGroup':
        this.costReviewChillerPlant.isChillerPlantApplicable = checked;
        break;
      case 'heatingPlantFormGroup':
        this.costReviewHeatingPlant.isHeatingPlantApplicable = checked;
        break;
      case 'terminalControllersFormGroup':
        this.costReviewTerminalUnits.isTerminalControllersApplicable = checked;
        break;
      case 'labEquipmentFormGroup':
        this.costReviewLabEquipment.isLabEquipmentApplicable = checked;
        break;
      case 'vfdsFormGroup':
        this.costReviewVFDS.isVfdsApplicable = checked;
        break;
      case 'controlValvesFormGroup':
        this.costReviewControlValves.isControlValvesApplicable = checked;
        break;
      case 'afmssFormGroup':
        this.costReviewAfmss.isAfmsApplicable = checked;
        break;
    }
  }

  isSectionFieldsetDisabled(section: string): boolean {
    const disabled = this.getSectionDisabledState(section);
    this.sectionDisableState[section] = disabled;
    return disabled;
  }

  private _isAutomationElectricalMechanicalOverride?: boolean;

  get isAutomationElectricalMechanical(): boolean {
    if (this._isAutomationElectricalMechanicalOverride !== undefined) {
      return this._isAutomationElectricalMechanicalOverride;
    }
    return (
      this.business === this.constants.BUSINESS_AUTOMATION ||
      this.business === this.constants.BUSINESS_ELECTRICAL ||
      this.business === this.constants.BUSINESS_MECHANICAL
    );
  }

  // Optional setter for tests or overrides
  set isAutomationElectricalMechanical(value: boolean) {
    this._isAutomationElectricalMechanicalOverride = value;
  }

  // Getter/Setter for repeated check: not Security business
  private _isNotSecurityOverride?: boolean;

  get isNotSecurity(): boolean {
    if (this._isNotSecurityOverride !== undefined) {
      return this._isNotSecurityOverride;
    }
    return (
      this.business === this.constants.BUSINESS_AUTOMATION ||
      this.business === this.constants.BUSINESS_ELECTRICAL ||
      this.business === this.constants.BUSINESS_FIRE ||
      this.business === this.constants.BUSINESS_MECHANICAL
    );
  }

  set isNotSecurity(value: boolean) {
    this._isNotSecurityOverride = value;
  }


  // Getter for all businesses except Security
  get isAutomationElectricalFireMechanical(): boolean {
    return this.business === this.constants.BUSINESS_AUTOMATION ||
           this.business === this.constants.BUSINESS_ELECTRICAL ||
           this.business === this.constants.BUSINESS_FIRE ||
           this.business === this.constants.BUSINESS_MECHANICAL;
  }

  // Getter for Operator Workstation non-applicable and not Security
  get isOperatorWorkstationNotApplicableAndNotSecurity(): boolean {
    return !this.costReviewOperatorWorkstationSoftware?.isOpWorksationsSoftwareApplicable && 
           this.business !== this.constants.BUSINESS_SECURITY;
  }

  // Getter for AEM businesses with sale price greater than 150K
  get isAEMWithHighSalePrice(): boolean {
    return (this.business === this.constants.BUSINESS_AUTOMATION ||
            this.business === this.constants.BUSINESS_ELECTRICAL ||
            this.business === this.constants.BUSINESS_MECHANICAL) &&
           this.isSalePriceGreaterThan150;
  }

  get isFire(): boolean {
    return this.business === this.constants.BUSINESS_FIRE;
  }

  private _isNetworkConfigurationDisabledOverride?: boolean;

  get isNetworkConfigurationDisabled(): boolean {
    if (this._isNetworkConfigurationDisabledOverride !== undefined) {
      return this._isNetworkConfigurationDisabledOverride;
    }
    return this.isDisabled || this.formControlsValueForNumber(this.systemConfigurationFormGroup, 'numberOfNodes') === this.constants.ZERO;
  }

  set isNetworkConfigurationDisabled(value: boolean) {
    this._isNetworkConfigurationDisabledOverride = value;
  }

  // Data objects  used by the forms
  costReviewPreFab = new CostReviewPrefab();
  costReviewBuildingLevelNetworkPanels = new CostReviewBuildingLevelNetworkPanels();
  costReviewSystemAttributes = new CostReviewFireEnUsSystemAttributes();
  costReviewSystemConfiguration = new CostReviewFireEnUsSystemConfiguration();
  costReviewRetrofitConsiderations = new CostReviewFireEnUsRetrofitConsiderations();
  costReviewOperatorWorkstationSoftware = new CostReviewOperatorWorkstationSoftware();
  costReviewChillerPlant = new CostReviewChillerPlant();
  costReviewHeatingPlant = new CostReviewHeatingPlant();
  costReviewTerminalUnits = new CostReviewTerminalControllers();
  costReviewFln = new CostReviewFln();
  costReviewLabEquipment = new CostReviewLabEquipment();
  costReviewVFDS = new CostReviewVfds();
  costReviewControlValves = new CostReviewControlValves();
  costReviewAfmss = new CostReviewAfms();

  preFabControllerFormGroup!: FormGroup<IPreFabControllerForm>;
  buildingLevelNetworkPanelsFormGroup!: FormGroup<IBuildingLevelNetworkPanelsForm>;
  systemAttributesFormGroup!: FormGroup<ISystemAttributesForm>;
  systemConfigurationFormGroup!: FormGroup<ISystemConfigurationForm>;
  retrofitConsiderationsFormGroup!: FormGroup<IRetrofitConsiderationsForm>;
  operatorWorkstationFormGroup!: FormGroup<IOperatorWorkstationForm>;
  chillerPlantFormGroup!: FormGroup<IChillerPlantForm>;
  heatingPlantFormGroup!: FormGroup<IHeatingPlantForm>;
  flnFormGroup!: FormGroup<IFlnForm>;
  terminalControllersFormGroup!: FormGroup<ITerminalControllersForm>;
  labEquipmentFormGroup!: FormGroup<ILabEquipmentForm>;
  vfdsFormGroup!: FormGroup<IVfdsForm>;
  controlValvesFormGroup!: FormGroup<IControlValvesForm>;
  afmssFormGroup!: FormGroup<IAfmssForm>;
  estimateType = CostReviewEstimateType.None;

  constructor(
    private readonly reviewService: ReviewService,
    private readonly formBuilder: NonNullableFormBuilder,
    private readonly commonDataService: CommonDataService,
    private readonly reviewDetailsTabService: ReviewDetailTabsService,
    private readonly commonFunctionsService: CommonFunctionsService,
  ) { }

  ngOnInit() {
    this.getReviewLibraryState();
    this.estimateType = this.convertToEstimateType(
      this.reviewDetailsTabService.getOptionalWorkflowAndEstimateType().optionalEstimateType
    );
    this.isSalePriceGreaterThan150 = this.estimateType === CostReviewEstimateType.EstimateGreater150K;
    this.batteryBackupList = this.getDropdownValues(this.constants.BATTERY_BACKUP);
    this.safeInitialize();
    this.createAllFormGroups();
    this.optionalWorkflowCondition = this.reviewDetailsTabService.getOptionalWorkflowAndEstimateType()?.optionalWorkflow || false;
    this.initializeSectionToggleState();
    this.populateReasonForExceptionDropdown();
    this.setupChildFieldDisabledState();
    this.setupReadOnlyMode();
    this.subscribeToReviewFormDataSyncRequest();
    this.subscribeToNumberOfNodesChanges();
  }

  /** Allows the host app to force this tab to push its latest data without waiting for tab switch/destroy. */
  private subscribeToReviewFormDataSyncRequest(): void {
    this.reviewDetailsTabService.getReviewFormDataSyncRequested$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.pushFormDataToService());
  }

   private convertToEstimateType(optionalEstimateType: CostReviewEstimateType | undefined): CostReviewEstimateType {
      switch (optionalEstimateType) {
        case CostReviewEstimateType.EstimateLess50K:
          return CostReviewEstimateType.EstimateLess50K;
        case CostReviewEstimateType.Estimate50_150K:
          return CostReviewEstimateType.Estimate50_150K;      
        case CostReviewEstimateType.EstimateGreater150K:
          return CostReviewEstimateType.EstimateGreater150K;
        default:
          return CostReviewEstimateType.None;
      }
    }

  private setupReadOnlyMode(): void {
    this.commonDataService.libraryReadOnlyMode$
      .pipe(takeUntil(this.destroy$))
      .subscribe((readOnly: boolean) => {
        this.formChangesSubscription?.unsubscribe();
        const isLibraryUsedInSQ = this.reviewDetailsTabService.getIsLibraryUsedInSQ();
        if (isLibraryUsedInSQ) {
          this.isDisabled = readOnly;
          this.isReadOnlyMode = false;
        } else {
          // Web behavior
          this.isDisabled = readOnly;
          this.isReadOnlyMode = readOnly;
        }
        this.refreshSectionDisabledStates();
        this.updateSystemConfigurationEditability();
        this.updateSystemAttributesEditability();
      });
}

  private refreshSectionDisabledStates(): void {
    for (const section of Object.keys(this.sectionToggleState)) {
      this.sectionDisableState[section] =
        this.getSectionDisabledState(section);
    }

    for (const [section, controlNames] of Object.entries(this.childFieldsBySection)) {
      const formGroup = this[section as keyof this] as FormGroup | undefined;

      if (formGroup) {
        this.updateChildFieldDisabledState(
          section,
          formGroup,
          controlNames
        );
      }
    }
  }

  ngOnDestroy() {
    this.pushFormDataToService();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private pushFormDataToService(): void {
    switch (this.business) {
      case this.constants.BUSINESS_AUTOMATION:
      case this.constants.BUSINESS_ELECTRICAL:
      case this.constants.BUSINESS_MECHANICAL:
        this.pushBuildingLevelNetworkPanelsFormData();
        this.pushChillerPlantFormData();
        this.pushHeatingPlantFormData();
        this.pushFlnFormData();
        this.pushTerminalControllersFormData();
        this.pushLabEquipmentFormData();
        this.pushVfdsFormData();
        this.pushControlValvesFormData();
        this.pushAfmssFormData();
        this.pushOperatorWorkstationFormData();
        break;

      case this.constants.BUSINESS_FIRE:
        this.pushSystemAttributesFormData();
        this.pushSystemConfigurationFormData();
        this.pushRetrofitConsiderationsFormData();
        this.pushOperatorWorkstationFormData();
        break;

      case this.constants.BUSINESS_SECURITY:
        break;
    }

    this.attachReviewObjectReferences();
  }

  private attachReviewObjectReferences(): void {
    const reviewObject = this.reviewService.getOrCreateReviewObjectForBusiness(this.business);
    if (!reviewObject) {
      return;
    }

    // Base class property for all businesses except Security.
    if (this.business !== this.constants.BUSINESS_SECURITY) {
      reviewObject.costReviewOperatorWorkstationSoftware = this.costReviewOperatorWorkstationSoftware;
    }

    switch (this.business) {
      case this.constants.BUSINESS_AUTOMATION:
      case this.constants.BUSINESS_ELECTRICAL:
      case this.constants.BUSINESS_MECHANICAL: {
        const attrs = reviewObject as CostReviewAttributes;
        attrs.costReviewPrefab = this.costReviewPreFab;
        attrs.costReviewBuildingLevelNetworkPanels = this.costReviewBuildingLevelNetworkPanels;
        attrs.costReviewChillerPlant = this.costReviewChillerPlant;
        attrs.costReviewHeatingPlant = this.costReviewHeatingPlant;
        attrs.costReviewTerminalControllers = this.costReviewTerminalUnits;
        attrs.costReviewFln = this.costReviewFln;
        attrs.costReviewLabEquipment = this.costReviewLabEquipment;
        attrs.costReviewVfds = this.costReviewVFDS;
        attrs.costReviewControlValves = this.costReviewControlValves;
        attrs.costReviewAfms = this.costReviewAfmss;
        break;
      }

      case this.constants.BUSINESS_FIRE: {
        const fire = reviewObject as CostReviewFireEnUsAttributes;
        fire.costReviewFireEnUsSystemAttributes = this.costReviewSystemAttributes;
        fire.costReviewFireEnUsSystemConfiguration = this.costReviewSystemConfiguration;
        fire.costReviewFireEnUsRetrofitConsiderations = this.costReviewRetrofitConsiderations;
        break;
      }

      case this.constants.BUSINESS_SECURITY:
        break;
    }
  }

  private pushBuildingLevelNetworkPanelsFormData(): void {
    if (this.buildingLevelNetworkPanelsFormGroup) {
      if(!this.costReviewBuildingLevelNetworkPanels){
        this.costReviewBuildingLevelNetworkPanels = new CostReviewBuildingLevelNetworkPanels();
      }
      const formData: BuildingLevelNetworkPanelsFormValue = this.buildingLevelNetworkPanelsFormGroup.getRawValue();
      this.costReviewBuildingLevelNetworkPanels.numberOfBuildingLevelNetworks = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfBuildingLevelNetworks, this.costReviewBuildingLevelNetworkPanels.numberOfBuildingLevelNetworks);
      this.costReviewBuildingLevelNetworkPanels.fieldPanelProductName = formData.fieldPanelProductName;
      this.costReviewBuildingLevelNetworkPanels.numberOfFieldPanelDrivers = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfFieldPanelDrivers, this.costReviewBuildingLevelNetworkPanels.numberOfFieldPanelDrivers);
      this.costReviewBuildingLevelNetworkPanels.equipmentManagedByPanelDrivers = formData.equipmentManagedByPanelDrivers;
      this.costReviewBuildingLevelNetworkPanels.sparePanelCapacity = this.commonFunctionsService.toNumberOrCurrent(formData.sparePanelCapacity, this.costReviewBuildingLevelNetworkPanels.sparePanelCapacity);
      this.costReviewBuildingLevelNetworkPanels.networkBy = this.getParameterCode(this.constants.SIEMENS_CUSTOMER, formData.networkBy, this.costReviewBuildingLevelNetworkPanels.networkBy);
      this.costReviewBuildingLevelNetworkPanels.networkHardwareIncluded = this.getParameterCode(this.constants.YES_NO, formData.networkHardwareIncluded, this.costReviewBuildingLevelNetworkPanels.networkHardwareIncluded);
      this.costReviewBuildingLevelNetworkPanels.networkSpecificationsReviewed = this.getParameterCode(this.constants.YES_NO, formData.networkSpecificationsReviewed, this.costReviewBuildingLevelNetworkPanels.networkSpecificationsReviewed);
      this.costReviewBuildingLevelNetworkPanels.fiberOpticsRequired = this.getParameterCode(this.constants.YES_NO, formData.fiberOpticsRequired, this.costReviewBuildingLevelNetworkPanels.fiberOpticsRequired);
    }
  }

  private pushSystemAttributesFormData(): void {
    if (this.systemAttributesFormGroup) {
      if(!this.costReviewSystemAttributes){
        this.costReviewSystemAttributes = new CostReviewFireEnUsSystemAttributes();
      }
      const formData: SystemAttributesFormValue = this.systemAttributesFormGroup.getRawValue();
      this.costReviewSystemAttributes.installType = this.getParameterCode(this.constants.INSTALL_TYPE, formData.installType, this.costReviewSystemAttributes.installType);
      this.costReviewSystemAttributes.systemType = this.getParameterCode(this.constants.SYSTEM_TYPE, formData.systemType, this.costReviewSystemAttributes.systemType);
      this.costReviewSystemAttributes.additionalSystems = this.commonFunctionsService.toNumberArray(formData.additionalSystems, this.additionalSystemsOptions);
    }
  }

  private pushSystemConfigurationFormData(): void {
    if (this.systemConfigurationFormGroup) {
      if(!this.costReviewSystemConfiguration){
        this.costReviewSystemConfiguration = new CostReviewFireEnUsSystemConfiguration();
      }
      const formData: SystemConfigurationFormValue = this.systemConfigurationFormGroup.getRawValue();
      this.costReviewSystemConfiguration.desigoPanels = this.commonFunctionsService.toNumberArray(formData.desigoPanels, this.desigoPanelsOptions);
      this.costReviewSystemConfiguration.voiceSystem = this.getParameterCode(this.constants.YES_NO, formData.voiceSystem, this.costReviewSystemConfiguration.voiceSystem);
      this.costReviewSystemConfiguration.globalVoice = this.getParameterCode(this.constants.YES_NO, formData.globalVoice, this.costReviewSystemConfiguration.globalVoice);
      this.costReviewSystemConfiguration.backupAmps = this.commonFunctionsService.toNumberArray(formData.backupAmps, this.backupAmpsOptions);
      this.costReviewSystemConfiguration.batteryBackup = this.getParameterCode(this.constants.BATTERY_BACKUP, formData.batteryBackup, this.costReviewSystemConfiguration.batteryBackup);
      this.costReviewSystemConfiguration.nacWiring = this.getParameterCode(this.constants.CLASS_A_B, formData.nacWiring, this.costReviewSystemConfiguration.nacWiring);
      this.costReviewSystemConfiguration.idcWiring = this.getParameterCode(this.constants.CLASS_A_B, formData.idcWiring, this.costReviewSystemConfiguration.idcWiring);
      this.costReviewSystemConfiguration.slcWiring = this.getParameterCode(this.constants.CLASS_A_B_X, formData.slcWiring, this.costReviewSystemConfiguration.slcWiring);
      this.costReviewSystemConfiguration.dialerProvidedBySiemens = this.getParameterCode(this.constants.YES_NO, formData.dialerProvidedBySiemens, this.costReviewSystemConfiguration.dialerProvidedBySiemens);
      this.costReviewSystemConfiguration.communicationMethod = this.getParameterCode(this.constants.COMMUNICATION_METHOD, formData.communicationMethod, this.costReviewSystemConfiguration.communicationMethod);
      this.costReviewSystemConfiguration.mxlvDesigoFsmMigration = this.getParameterCode(this.constants.YES_NO, formData.mxlvDesigoFsmMigration, this.costReviewSystemConfiguration.mxlvDesigoFsmMigration);
      this.costReviewSystemConfiguration.proposedSystem = this.getParameterCode(this.constants.YES_NO, formData.proposedSystem, this.costReviewSystemConfiguration.proposedSystem);
      this.costReviewSystemConfiguration.numberOfNodes = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfNodes, this.costReviewSystemConfiguration.numberOfNodes);
      this.costReviewSystemConfiguration.networkStyle = this.getParameterCode(this.constants.NETWORK_STYLE, formData.networkStyle, this.costReviewSystemConfiguration.networkStyle);
      this.costReviewSystemConfiguration.networkOptions = this.commonFunctionsService.toNumberArray(formData.networkOptions, this.networkOptionsArray);
    }
  }

  private pushRetrofitConsiderationsFormData(): void {
    if (this.retrofitConsiderationsFormGroup) {
      if(!this.costReviewRetrofitConsiderations){
        this.costReviewRetrofitConsiderations = new CostReviewFireEnUsRetrofitConsiderations();
      }
      const formData: RetrofitConsiderationsFormValue = this.retrofitConsiderationsFormGroup.getRawValue();
      this.costReviewRetrofitConsiderations.systemComponentReuse = this.getParameterCode(this.constants.YES_NO, formData.systemComponentReuse, this.costReviewRetrofitConsiderations.systemComponentReuse);
      this.costReviewRetrofitConsiderations.exceptions = formData.exceptions;
      this.costReviewRetrofitConsiderations.existingSystemManufacturer = formData.existingSystemManufacturer;
      this.costReviewRetrofitConsiderations.existingSystemModel = formData.existingSystemModel;
      this.costReviewRetrofitConsiderations.operationalDuringRetrofit = this.getParameterCode(this.constants.YES_NO, formData.operationalDuringRetrofit, this.costReviewRetrofitConsiderations.operationalDuringRetrofit);
      this.costReviewRetrofitConsiderations.sufficientSpaceToMount = this.getParameterCode(this.constants.YES_NO, formData.sufficientSpaceToMount, this.costReviewRetrofitConsiderations.sufficientSpaceToMount);
      this.costReviewRetrofitConsiderations.conditionsVerified = this.getParameterCode(this.constants.YES_NO, formData.conditionsVerified, this.costReviewRetrofitConsiderations.conditionsVerified);
      this.costReviewRetrofitConsiderations.existingWiringReused = this.getParameterCode(this.constants.YES_NO, formData.existingWiringReused, this.costReviewRetrofitConsiderations.existingWiringReused);
      this.costReviewRetrofitConsiderations.subcontractorIsAware = this.getParameterCode(this.constants.YES_NO, formData.subcontractorIsAware, this.costReviewRetrofitConsiderations.subcontractorIsAware);
      this.costReviewRetrofitConsiderations.wiringIsCompatible = this.getParameterCode(this.constants.YES_NO, formData.wiringIsCompatible, this.costReviewRetrofitConsiderations.wiringIsCompatible);
      this.costReviewRetrofitConsiderations.conduitOrRacewayReuse = this.getParameterCode(this.constants.YES_NO, formData.conduitOrRacewayReuse, this.costReviewRetrofitConsiderations.conduitOrRacewayReuse);
      this.costReviewRetrofitConsiderations.fireWatchRequired = this.getParameterCode(this.constants.YES_NO, formData.fireWatchRequired, this.costReviewRetrofitConsiderations.fireWatchRequired);
      this.costReviewRetrofitConsiderations.responsibleForComponent = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.responsibleForComponent, this.costReviewRetrofitConsiderations.responsibleForComponent);
    }
  }

  private pushOperatorWorkstationFormData(): void {
    if (this.operatorWorkstationFormGroup) {
      if(!this.costReviewOperatorWorkstationSoftware){
        this.costReviewOperatorWorkstationSoftware = new CostReviewOperatorWorkstationSoftware();
      }
      const formData: OperatorWorkstationFormValue = this.operatorWorkstationFormGroup.getRawValue();
      this.costReviewOperatorWorkstationSoftware.numberOfServers = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfServers, this.costReviewOperatorWorkstationSoftware.numberOfServers);
      this.costReviewOperatorWorkstationSoftware.numberOfWorkstations = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfWorkstations, this.costReviewOperatorWorkstationSoftware.numberOfWorkstations);
      this.costReviewOperatorWorkstationSoftware.numberOfClients = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfClients, this.costReviewOperatorWorkstationSoftware.numberOfClients);
      this.costReviewOperatorWorkstationSoftware.competitorSystem = formData.competitorSystem;
      this.costReviewOperatorWorkstationSoftware.internetAccessible = this.getParameterCode(this.constants.YES_NO, formData.internetAccessible, this.costReviewOperatorWorkstationSoftware.internetAccessible);
      this.costReviewOperatorWorkstationSoftware.featuresRequired = formData.featuresRequired;
      this.costReviewOperatorWorkstationSoftware.aptUtilized = this.getParameterCode(this.constants.YES_NO, formData.aptUtilized, this.costReviewOperatorWorkstationSoftware.aptUtilized);
      this.costReviewOperatorWorkstationSoftware.numberOfPrograms = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfPrograms, this.costReviewOperatorWorkstationSoftware.numberOfPrograms);
      this.costReviewOperatorWorkstationSoftware.numberOfGraphics = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfGraphics, this.costReviewOperatorWorkstationSoftware.numberOfGraphics);
      this.costReviewOperatorWorkstationSoftware.centralizedGraphicsUtilized = this.getParameterCode(this.constants.YES_NO, formData.centralizedGraphicsUtilized, this.costReviewOperatorWorkstationSoftware.centralizedGraphicsUtilized);
      this.costReviewOperatorWorkstationSoftware.geccUtilized = this.getParameterCode(this.constants.YES_NO, formData.geccUtilized, this.costReviewOperatorWorkstationSoftware.geccUtilized);
      this.costReviewOperatorWorkstationSoftware.protocols = this.commonFunctionsService.toNumberArray(formData.protocols, this.operatorProtocolOptions);
      this.costReviewOperatorWorkstationSoftware.numberOfSwitches = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfSwitches, this.costReviewOperatorWorkstationSoftware.numberOfSwitches);
    }
  }

  private pushChillerPlantFormData(): void {
    if (this.chillerPlantFormGroup) {
      if(!this.costReviewChillerPlant){
        this.costReviewChillerPlant = new CostReviewChillerPlant();
      }
      const formData: ChillerPlantFormValue = this.chillerPlantFormGroup.getRawValue();
      this.costReviewChillerPlant.numberOfChillers = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfChillers, this.costReviewChillerPlant.numberOfChillers);
      this.costReviewChillerPlant.manufacturerChillers = formData.manufacturerChillers;
      this.costReviewChillerPlant.driversChiller = this.getParameterCode(this.constants.HARDWIRED_INTEGRATION, formData.driversChiller, this.costReviewChillerPlant.driversChiller);
      this.costReviewChillerPlant.chillersControlsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.chillersControlsFurnishedBy, this.costReviewChillerPlant.chillersControlsFurnishedBy);
      this.costReviewChillerPlant.chillersControlsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.chillersControlsInstalledBy, this.costReviewChillerPlant.chillersControlsInstalledBy);
      this.costReviewChillerPlant.chillersControlsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.chillersControlsWiredBy, this.costReviewChillerPlant.chillersControlsWiredBy);
      this.costReviewChillerPlant.numberOfTowers = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfTowers, this.costReviewChillerPlant.numberOfTowers);
      this.costReviewChillerPlant.manufacturerTowers = formData.manufacturerTowers;
      this.costReviewChillerPlant.driversTowers = this.getParameterCode(this.constants.HARDWIRED_INTEGRATION, formData.driversTowers, this.costReviewChillerPlant.driversTowers);
      this.costReviewChillerPlant.towersControlsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.towersControlsFurnishedBy, this.costReviewChillerPlant.towersControlsFurnishedBy);
      this.costReviewChillerPlant.towersControlsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.towersControlsInstalledBy, this.costReviewChillerPlant.towersControlsInstalledBy);
      this.costReviewChillerPlant.towersControlsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.towersControlsWiredBy, this.costReviewChillerPlant.towersControlsWiredBy);
      this.costReviewChillerPlant.numberOfPumps = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfPumps, this.costReviewChillerPlant.numberOfPumps);
      this.costReviewChillerPlant.manufacturerPumps = formData.manufacturerPumps;
      this.costReviewChillerPlant.driversPumps = this.getParameterCode(this.constants.HARDWIRED_INTEGRATION, formData.driversPumps, this.costReviewChillerPlant.driversPumps);
      this.costReviewChillerPlant.pumpsSensorsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.pumpsSensorsFurnishedBy, this.costReviewChillerPlant.pumpsSensorsFurnishedBy);
      this.costReviewChillerPlant.pumpsSensorsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.pumpsSensorsInstalledBy, this.costReviewChillerPlant.pumpsSensorsInstalledBy);
      this.costReviewChillerPlant.pumpsSensorsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.pumpsSensorsWiredBy, this.costReviewChillerPlant.pumpsSensorsWiredBy);
    }
  }

  private pushHeatingPlantFormData(): void {
    if (this.heatingPlantFormGroup) {
      if(!this.costReviewHeatingPlant){
        this.costReviewHeatingPlant = new CostReviewHeatingPlant();
      }
      const formData: HeatingPlantFormValue = this.heatingPlantFormGroup.getRawValue();
      this.costReviewHeatingPlant.numberOfBoilers = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfBoilers, this.costReviewHeatingPlant.numberOfBoilers);
      this.costReviewHeatingPlant.manufacturerBoilers = formData.manufacturerBoilers;
      this.costReviewHeatingPlant.driversBoilers = this.getParameterCode(this.constants.HARDWIRED_INTEGRATED, formData.driversBoilers, this.costReviewHeatingPlant.driversBoilers);
      this.costReviewHeatingPlant.boilersControlsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.boilersControlsFurnishedBy, this.costReviewHeatingPlant.boilersControlsFurnishedBy);
      this.costReviewHeatingPlant.boilersControlsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.boilersControlsInstalledBy, this.costReviewHeatingPlant.boilersControlsInstalledBy);
      this.costReviewHeatingPlant.boilersControlsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.boilersControlsWiredBy, this.costReviewHeatingPlant.boilersControlsWiredBy);
      this.costReviewHeatingPlant.numberOfTowers = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfTowers, this.costReviewHeatingPlant.numberOfTowers);
      this.costReviewHeatingPlant.manufacturerTowers = formData.manufacturerTowers;
      this.costReviewHeatingPlant.driversTowers = this.getParameterCode(this.constants.HARDWIRED_INTEGRATION, formData.driversTowers, this.costReviewHeatingPlant.driversTowers);
      this.costReviewHeatingPlant.towersControlsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.towersControlsFurnishedBy, this.costReviewHeatingPlant.towersControlsFurnishedBy);
      this.costReviewHeatingPlant.towersControlsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.towersControlsInstalledBy, this.costReviewHeatingPlant.towersControlsInstalledBy);
      this.costReviewHeatingPlant.towersControlsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.towersControlsWiredBy, this.costReviewHeatingPlant.towersControlsWiredBy);
      this.costReviewHeatingPlant.numberOfPumps = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfPumps, this.costReviewHeatingPlant.numberOfPumps);
      this.costReviewHeatingPlant.manufacturerPumps = formData.manufacturerPumps;
      this.costReviewHeatingPlant.driversPumps = this.getParameterCode(this.constants.HARDWIRED_INTEGRATION, formData.driversPumps, this.costReviewHeatingPlant.driversPumps);
      this.costReviewHeatingPlant.pumpsSensorsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.pumpsSensorsFurnishedBy, this.costReviewHeatingPlant.pumpsSensorsFurnishedBy);
      this.costReviewHeatingPlant.pumpsSensorsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.pumpsSensorsInstalledBy, this.costReviewHeatingPlant.pumpsSensorsInstalledBy);
      this.costReviewHeatingPlant.pumpsSensorsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.pumpsSensorsWiredBy, this.costReviewHeatingPlant.pumpsSensorsWiredBy);
    }
  }

  private pushFlnFormData(): void {
    if (this.flnFormGroup) {
      if(!this.costReviewFln){
        this.costReviewFln = new CostReviewFln();
      }
      const formData: FlnFormValue = this.flnFormGroup.getRawValue();
      this.costReviewFln.numberOfVfds = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfVfds, this.costReviewFln.numberOfVfds);
      this.costReviewFln.productName = formData.productName;
      this.costReviewFln.otherFlnMstpDevices = formData.otherFlnMstpDevices;
      this.costReviewFln.networkType = this.commonFunctionsService.toNumberArray(formData.networkType, this.flnNetworkTypeOptions);
    }
  }

  private pushTerminalControllersFormData(): void {
    if (this.terminalControllersFormGroup) {
      if(!this.costReviewTerminalUnits){
        this.costReviewTerminalUnits = new CostReviewTerminalControllers();
      }
      const formData: TerminalControllersFormValue = this.terminalControllersFormGroup.getRawValue();
      this.costReviewTerminalUnits.controllerType = this.commonFunctionsService.toNumberArray(formData.controllerType, this.terminalControllerTypeOptions);
      this.costReviewTerminalUnits.numberOfTerminalUnits = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfTerminalUnits, this.costReviewTerminalUnits.numberOfTerminalUnits);
      this.costReviewTerminalUnits.numberOfVavs = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfVavs, this.costReviewTerminalUnits.numberOfVavs);
      this.costReviewTerminalUnits.manufacturerVavs = formData.manufacturerVavs;
      this.costReviewTerminalUnits.customApplicationsRequired = this.getParameterCode(this.constants.YES_NO, formData.customApplicationsRequired, this.costReviewTerminalUnits.customApplicationsRequired);
      this.costReviewTerminalUnits.vavsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.vavsInstalledBy, this.costReviewTerminalUnits.vavsInstalledBy);
      this.costReviewTerminalUnits.numberOfFcus = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfFcus, this.costReviewTerminalUnits.numberOfFcus);
      this.costReviewTerminalUnits.manufacturerFcus = formData.manufacturerFcus;
      this.costReviewTerminalUnits.fcusInstalledBy = this.getParameterCode(this.constants.FCU_INSTALLED_BY, formData.fcusInstalledBy, this.costReviewTerminalUnits.fcusInstalledBy);
      this.costReviewTerminalUnits.numberOfUvs = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfUvs, this.costReviewTerminalUnits.numberOfUvs);
      this.costReviewTerminalUnits.manufacturerUvs = formData.manufacturerUvs;
      this.costReviewTerminalUnits.unitsControlsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsControlsFurnishedBy, this.costReviewTerminalUnits.unitsControlsFurnishedBy);
      this.costReviewTerminalUnits.unitsControlsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsControlsInstalledBy, this.costReviewTerminalUnits.unitsControlsInstalledBy);
      this.costReviewTerminalUnits.unitsControlsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsControlsWiredBy, this.costReviewTerminalUnits.unitsControlsWiredBy);
      this.costReviewTerminalUnits.power = this.getParameterCode(this.constants.POWERTRUNK_LOCALPOWER, formData.power, this.costReviewTerminalUnits.power);
      this.costReviewTerminalUnits.installingPneumaticTubing = this.getParameterCode(this.constants.YES_NO, formData.installingPneumaticTubing, this.costReviewTerminalUnits.installingPneumaticTubing);
    }
  }

  private pushLabEquipmentFormData(): void {
    if (this.labEquipmentFormGroup) {
      if(!this.costReviewLabEquipment){
        this.costReviewLabEquipment = new CostReviewLabEquipment();
      }
      const formData: LabEquipmentFormValue = this.labEquipmentFormGroup.getRawValue();
      this.costReviewLabEquipment.numberOfTerminalUnits = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfTerminalUnits, this.costReviewLabEquipment.numberOfTerminalUnits);
      this.costReviewLabEquipment.manufacturer = formData.manufacturer;
      this.costReviewLabEquipment.airValvesFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.airValvesFurnishedBy, this.costReviewLabEquipment.airValvesFurnishedBy);
      this.costReviewLabEquipment.airValvesInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.airValvesInstalledBy, this.costReviewLabEquipment.airValvesInstalledBy);
      this.costReviewLabEquipment.controlsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.controlsFurnishedBy, this.costReviewLabEquipment.controlsFurnishedBy);
      this.costReviewLabEquipment.controlsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.controlsInstalledBy, this.costReviewLabEquipment.controlsInstalledBy);
      this.costReviewLabEquipment.controlsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.controlsWiredBy, this.costReviewLabEquipment.controlsWiredBy);
      this.costReviewLabEquipment.networkType = this.getParameterCode(this.constants.ETHERNET_MSTP, formData.networkType, this.costReviewLabEquipment.networkType);
      this.costReviewLabEquipment.power = this.getParameterCode(this.constants.POWERTRUNK_LOCALPOWER, formData.power, this.costReviewLabEquipment.power);
    }
  }

  private pushVfdsFormData(): void {
    if (this.vfdsFormGroup) {
      if(!this.costReviewVFDS){
        this.costReviewVFDS = new CostReviewVfds();
      }
      const formData: VfdsFormValue = this.vfdsFormGroup.getRawValue();
      this.costReviewVFDS.numberOfVfds = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfVfds, this.costReviewVFDS.numberOfVfds);
      this.costReviewVFDS.manufacturer = formData.manufacturer;
      this.costReviewVFDS.drivers = this.getParameterCode(this.constants.HARDWIRED_INTEGRATION, formData.drivers, this.costReviewVFDS.drivers);
      this.costReviewVFDS.unitsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsFurnishedBy, this.costReviewVFDS.unitsFurnishedBy);
      this.costReviewVFDS.unitsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsInstalledBy, this.costReviewVFDS.unitsInstalledBy);
      this.costReviewVFDS.unitsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsWiredBy, this.costReviewVFDS.unitsWiredBy);
    }
  }

  private pushControlValvesFormData(): void {
    if (this.controlValvesFormGroup) {
      if(!this.costReviewControlValves){
        this.costReviewControlValves = new CostReviewControlValves();
      }
      const formData: ControlValvesFormValue = this.controlValvesFormGroup.getRawValue();
      this.costReviewControlValves.numberOfValves = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfValves, this.costReviewControlValves.numberOfValves);
      this.costReviewControlValves.manufacturer = formData.manufacturer;
      this.costReviewControlValves.applications = this.commonFunctionsService.toNumberArray(formData.applications, this.controlValvesApplicationOptions);
      this.costReviewControlValves.unitsActuatorsFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsActuatorsFurnishedBy, this.costReviewControlValves.unitsActuatorsFurnishedBy);
      this.costReviewControlValves.unitsActuatorsInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsActuatorsInstalledBy, this.costReviewControlValves.unitsActuatorsInstalledBy);
      this.costReviewControlValves.unitsActuatorsWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsActuatorsWiredBy, this.costReviewControlValves.unitsActuatorsWiredBy);
    }
  }

  private pushAfmssFormData(): void {
    if (this.afmssFormGroup) {
      if(!this.costReviewAfmss){
        this.costReviewAfmss = new CostReviewAfms();
      }
      const formData: AfmssFormValue = this.afmssFormGroup.getRawValue();
      this.costReviewAfmss.numberOfAfms = this.commonFunctionsService.toNumberOrCurrent(formData.numberOfAfms, this.costReviewAfmss.numberOfAfms);
      this.costReviewAfmss.manufacturer = formData.manufacturer;
      this.costReviewAfmss.applications = this.commonFunctionsService.toNumberArray(formData.applications, this.afmssApplicationOptions);
      this.costReviewAfmss.afmsSchedule = this.getParameterCode(this.constants.YES_NO, formData.afmsSchedule, this.costReviewAfmss.afmsSchedule);
      this.costReviewAfmss.unitsDevicesFurnishedBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsDevicesFurnishedBy, this.costReviewAfmss.unitsDevicesFurnishedBy);
      this.costReviewAfmss.unitsDevicesInstalledBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsDevicesInstalledBy, this.costReviewAfmss.unitsDevicesInstalledBy);
      this.costReviewAfmss.unitsDevicesWiredBy = this.getParameterCode(this.constants.SIEMENS_OTHER, formData.unitsDevicesWiredBy, this.costReviewAfmss.unitsDevicesWiredBy);
    }
  }

  safeInitialize() {
    const costReviewObj = this.reviewService.costReviewDetails.reviewObject;
    this.business = this.reviewService.getBusiness();
    if (!costReviewObj) {
      return;
    }

    // Base class property – available for all businesses except Security
    this.costReviewOperatorWorkstationSoftware = costReviewObj.costReviewOperatorWorkstationSoftware ?? this.costReviewOperatorWorkstationSoftware;

    switch (this.business) {
      case this.constants.BUSINESS_AUTOMATION:
      case this.constants.BUSINESS_ELECTRICAL:
      case this.constants.BUSINESS_MECHANICAL: {
        const attrs = costReviewObj as CostReviewAttributes;
        this.costReviewPreFab = attrs.costReviewPrefab ?? this.costReviewPreFab;
        this.costReviewBuildingLevelNetworkPanels = attrs.costReviewBuildingLevelNetworkPanels ?? this.costReviewBuildingLevelNetworkPanels;
        this.costReviewChillerPlant = attrs.costReviewChillerPlant ?? this.costReviewChillerPlant;
        this.costReviewHeatingPlant = attrs.costReviewHeatingPlant ?? this.costReviewHeatingPlant;
        this.costReviewTerminalUnits = attrs.costReviewTerminalControllers ?? this.costReviewTerminalUnits;
        this.costReviewFln = attrs.costReviewFln ?? this.costReviewFln;
        this.costReviewLabEquipment = attrs.costReviewLabEquipment ?? this.costReviewLabEquipment;
        this.costReviewVFDS = attrs.costReviewVfds ?? this.costReviewVFDS;
        this.costReviewControlValves = attrs.costReviewControlValves ?? this.costReviewControlValves;
        this.costReviewAfmss = attrs.costReviewAfms ?? this.costReviewAfmss;
        break;
      }
      case this.constants.BUSINESS_FIRE: {
        const fire = costReviewObj as CostReviewFireEnUsAttributes;
        this.costReviewSystemAttributes = fire.costReviewFireEnUsSystemAttributes ?? this.costReviewSystemAttributes;
        this.costReviewSystemConfiguration = fire.costReviewFireEnUsSystemConfiguration ?? this.costReviewSystemConfiguration;
        this.costReviewRetrofitConsiderations = fire.costReviewFireEnUsRetrofitConsiderations ?? this.costReviewRetrofitConsiderations;
        break;
      }
      case this.constants.BUSINESS_SECURITY:
        // Security has no part-one specific properties beyond the base class
        break;
    }
  }

  createAllFormGroups() {
    if (this.isAutomationElectricalMechanical) {
      this.createPreFabControllerForm();
      this.createBuildingLevelNetworkPanelsForm();
      this.createChillerPlantForm();
      this.createHeatingPlantForm();
      this.createTerminalControllersForm();
      this.createFlnForm();
      this.createLabEquipmentForm();
      this.createVfdsForm();
      this.createControlValvesForm();
      this.createAfmsForm();
    }

    if (this.business === this.constants.BUSINESS_FIRE) {
      this.createSystemAttributesForm();
      this.createSystemConfigurationForm();
      this.createRetrofitConsiderationsForm();
    }

    // Operator Workstation is a base-class property shown for all businesses except Security
    if (this.business !== this.constants.BUSINESS_SECURITY) {
      this.createOperatorWorkstationForm();
    }
  }

  createPreFabControllerForm() {
    this.preFabControllerFormGroup = this.formBuilder.group({
      prefabControllerUsed: this.formBuilder.control(this.costReviewPreFab.prefabControllerUsed),
      reasonForException: this.formBuilder.control(this.costReviewPreFab.reasonForException)
    });
  }

  onPrefabReasonForExceptionChange(value: string): void {
    if (this.isDisabled || this.isReadOnlyMode || !this.costReviewPreFab) {
      return;
    }

    this.preFabControllerFormGroup.controls.reasonForException.setValue(value, { emitEvent: false });
    if (this.costReviewPreFab.reasonForException === value) {
      return;
    }

    this.costReviewPreFab.reasonForException = value;
    this.reviewDetailsTabService.markAsUnsavedChanges();
    this.reviewService.notifyFieldChange(ActionNeededField.PrefabReasonForException, value);
  }

  createBuildingLevelNetworkPanelsForm() {
    this.buildingLevelNetworkPanelsFormGroup = this.formBuilder.group({
      numberOfBuildingLevelNetworks: this.formBuilder.control(this.costReviewBuildingLevelNetworkPanels.numberOfBuildingLevelNetworks || 0),
      fieldPanelProductName: this.formBuilder.control(this.costReviewBuildingLevelNetworkPanels.fieldPanelProductName),
      numberOfFieldPanelDrivers: this.formBuilder.control(this.costReviewBuildingLevelNetworkPanels.numberOfFieldPanelDrivers || 0),
      equipmentManagedByPanelDrivers: this.formBuilder.control(this.costReviewBuildingLevelNetworkPanels.equipmentManagedByPanelDrivers),
      sparePanelCapacity: this.formBuilder.control(this.costReviewBuildingLevelNetworkPanels.sparePanelCapacity || 0),
      networkBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_CUSTOMER, this.costReviewBuildingLevelNetworkPanels.networkBy)),
      networkHardwareIncluded: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewBuildingLevelNetworkPanels.networkHardwareIncluded)),
      networkSpecificationsReviewed: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewBuildingLevelNetworkPanels.networkSpecificationsReviewed)),
      fiberOpticsRequired: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewBuildingLevelNetworkPanels.fiberOpticsRequired))
    });
  }

  createSystemAttributesForm() {
    this.systemAttributesFormGroup = this.formBuilder.group({
      installType: this.formBuilder.control(this.getParameterValues(this.constants.INSTALL_TYPE, this.costReviewSystemAttributes.installType)),
      systemType: this.formBuilder.control(this.getParameterValues(this.constants.SYSTEM_TYPE, this.costReviewSystemAttributes.systemType)),
      additionalSystems: this.formBuilder.control(this.costReviewSystemAttributes.additionalSystems ?? [])
    });
  }

  createSystemConfigurationForm() {
    this.systemConfigurationFormGroup = this.formBuilder.group({
      desigoPanels: this.formBuilder.control(this.costReviewSystemConfiguration.desigoPanels),
      voiceSystem: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewSystemConfiguration.voiceSystem)),
      globalVoice: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewSystemConfiguration.globalVoice)),
      backupAmps: this.formBuilder.control(this.costReviewSystemConfiguration.backupAmps ?? []),
      batteryBackup: this.formBuilder.control(this.getParameterValues(this.constants.BATTERY_BACKUP, this.costReviewSystemConfiguration.batteryBackup)),
      nacWiring: this.formBuilder.control(this.getParameterValues(this.constants.CLASS_A_B, this.costReviewSystemConfiguration.nacWiring)),
      idcWiring: this.formBuilder.control(this.getParameterValues(this.constants.CLASS_A_B, this.costReviewSystemConfiguration.idcWiring)),
      slcWiring: this.formBuilder.control(this.getParameterValues(this.constants.CLASS_A_B_X, this.costReviewSystemConfiguration.slcWiring)),
      dialerProvidedBySiemens: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewSystemConfiguration.dialerProvidedBySiemens)),
      communicationMethod: this.formBuilder.control(this.getParameterValues(this.constants.COMMUNICATION_METHOD, this.costReviewSystemConfiguration.communicationMethod)),
      mxlvDesigoFsmMigration: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewSystemConfiguration.mxlvDesigoFsmMigration)),
      proposedSystem: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewSystemConfiguration.proposedSystem)),
      numberOfNodes: this.formBuilder.control(this.costReviewSystemConfiguration.numberOfNodes || 0),
      networkStyle: this.formBuilder.control(this.getParameterValues(this.constants.NETWORK_STYLE, this.costReviewSystemConfiguration.networkStyle)),
      networkOptions: this.formBuilder.control(this.costReviewSystemConfiguration.networkOptions)
    });
  }

  createRetrofitConsiderationsForm() {
    this.retrofitConsiderationsFormGroup = this.formBuilder.group({
      systemComponentReuse: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewRetrofitConsiderations.systemComponentReuse)),
      exceptions: this.formBuilder.control(this.costReviewRetrofitConsiderations.exceptions),
      existingSystemManufacturer: this.formBuilder.control(this.costReviewRetrofitConsiderations.existingSystemManufacturer),
      existingSystemModel: this.formBuilder.control(this.costReviewRetrofitConsiderations.existingSystemModel),
      operationalDuringRetrofit: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewRetrofitConsiderations.operationalDuringRetrofit)),
      sufficientSpaceToMount: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewRetrofitConsiderations.sufficientSpaceToMount)),
      conditionsVerified: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewRetrofitConsiderations.conditionsVerified)),
      existingWiringReused: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewRetrofitConsiderations.existingWiringReused)),
      subcontractorIsAware: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewRetrofitConsiderations.subcontractorIsAware)),
      wiringIsCompatible: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewRetrofitConsiderations.wiringIsCompatible)),
      conduitOrRacewayReuse: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewRetrofitConsiderations.conduitOrRacewayReuse)),
      fireWatchRequired: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewRetrofitConsiderations.fireWatchRequired)),
      responsibleForComponent: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewRetrofitConsiderations.responsibleForComponent)),
    });
  }

  createOperatorWorkstationForm() {
    this.operatorWorkstationFormGroup = this.formBuilder.group({
      numberOfServers: this.formBuilder.control(this.costReviewOperatorWorkstationSoftware.numberOfServers || 0),
      numberOfWorkstations: this.formBuilder.control(this.costReviewOperatorWorkstationSoftware.numberOfWorkstations || 0),
      numberOfClients: this.formBuilder.control(this.costReviewOperatorWorkstationSoftware.numberOfClients || 0),
      competitorSystem: this.formBuilder.control(this.costReviewOperatorWorkstationSoftware.competitorSystem),
      internetAccessible: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewOperatorWorkstationSoftware.internetAccessible)),
      featuresRequired: this.formBuilder.control(this.costReviewOperatorWorkstationSoftware.featuresRequired),
      aptUtilized: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewOperatorWorkstationSoftware.aptUtilized)),
      numberOfPrograms: this.formBuilder.control(this.costReviewOperatorWorkstationSoftware.numberOfPrograms || 0),
      numberOfGraphics: this.formBuilder.control(this.costReviewOperatorWorkstationSoftware.numberOfGraphics || 0),
      centralizedGraphicsUtilized: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewOperatorWorkstationSoftware.centralizedGraphicsUtilized)),
      geccUtilized: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewOperatorWorkstationSoftware.geccUtilized)),
      protocols: this.formBuilder.control(this.costReviewOperatorWorkstationSoftware.protocols ?? []),
      numberOfSwitches: this.formBuilder.control(this.costReviewOperatorWorkstationSoftware.numberOfSwitches || 0)
    });
  }

  createChillerPlantForm() {
    this.chillerPlantFormGroup = this.formBuilder.group({
      numberOfChillers: this.formBuilder.control(this.costReviewChillerPlant.numberOfChillers || 0),
      manufacturerChillers: this.formBuilder.control(this.costReviewChillerPlant.manufacturerChillers),
      driversChiller: this.formBuilder.control(this.getParameterValues(this.constants.HARDWIRED_INTEGRATION, this.costReviewChillerPlant.driversChiller)),
      chillersControlsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewChillerPlant.chillersControlsFurnishedBy)),
      chillersControlsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewChillerPlant.chillersControlsInstalledBy)),
      chillersControlsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewChillerPlant.chillersControlsWiredBy)),
      numberOfTowers: this.formBuilder.control(this.costReviewChillerPlant.numberOfTowers || 0),
      manufacturerTowers: this.formBuilder.control(this.costReviewChillerPlant.manufacturerTowers),
      driversTowers: this.formBuilder.control(this.getParameterValues(this.constants.HARDWIRED_INTEGRATION, this.costReviewChillerPlant.driversTowers)),
      towersControlsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewChillerPlant.towersControlsFurnishedBy)),
      towersControlsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewChillerPlant.towersControlsInstalledBy)),
      towersControlsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewChillerPlant.towersControlsWiredBy)),
      numberOfPumps: this.formBuilder.control(this.costReviewChillerPlant.numberOfPumps || 0),
      manufacturerPumps: this.formBuilder.control(this.costReviewChillerPlant.manufacturerPumps),
      driversPumps: this.formBuilder.control(this.getParameterValues(this.constants.HARDWIRED_INTEGRATION, this.costReviewChillerPlant.driversPumps)),
      pumpsSensorsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewChillerPlant.pumpsSensorsFurnishedBy)),
      pumpsSensorsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewChillerPlant.pumpsSensorsInstalledBy)),
      pumpsSensorsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewChillerPlant.pumpsSensorsWiredBy))
    });
  }

  createHeatingPlantForm() {
    this.heatingPlantFormGroup = this.formBuilder.group({
      numberOfBoilers: this.formBuilder.control(this.costReviewHeatingPlant.numberOfBoilers || 0),
      manufacturerBoilers: this.formBuilder.control(this.costReviewHeatingPlant.manufacturerBoilers),
      driversBoilers: this.formBuilder.control(this.getParameterValues(this.constants.HARDWIRED_INTEGRATED, this.costReviewHeatingPlant.driversBoilers)),
      boilersControlsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewHeatingPlant.boilersControlsFurnishedBy)),
      boilersControlsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewHeatingPlant.boilersControlsInstalledBy)),
      boilersControlsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewHeatingPlant.boilersControlsWiredBy)),
      numberOfTowers: this.formBuilder.control(this.costReviewHeatingPlant.numberOfTowers || 0),
      manufacturerTowers: this.formBuilder.control(this.costReviewHeatingPlant.manufacturerTowers),
      driversTowers: this.formBuilder.control(this.getParameterValues(this.constants.HARDWIRED_INTEGRATION, this.costReviewHeatingPlant.driversTowers)),
      towersControlsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewHeatingPlant.towersControlsFurnishedBy)),
      towersControlsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewHeatingPlant.towersControlsInstalledBy)),
      towersControlsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewHeatingPlant.towersControlsWiredBy)),
      numberOfPumps: this.formBuilder.control(this.costReviewHeatingPlant.numberOfPumps || 0),
      manufacturerPumps: this.formBuilder.control(this.costReviewHeatingPlant.manufacturerPumps),
      driversPumps: this.formBuilder.control(this.getParameterValues(this.constants.HARDWIRED_INTEGRATION, this.costReviewHeatingPlant.driversPumps)),
      pumpsSensorsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewHeatingPlant.pumpsSensorsFurnishedBy)),
      pumpsSensorsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewHeatingPlant.pumpsSensorsInstalledBy)),
      pumpsSensorsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewHeatingPlant.pumpsSensorsWiredBy))
    });
  }

  createFlnForm() {
    this.flnFormGroup = this.formBuilder.group({
      numberOfVfds: this.formBuilder.control(this.costReviewFln.numberOfVfds || 0),
      productName: this.formBuilder.control(this.costReviewFln.productName),
      otherFlnMstpDevices: this.formBuilder.control(this.costReviewFln.otherFlnMstpDevices),
      networkType: this.formBuilder.control(this.costReviewFln.networkType)
    });
  }

  createTerminalControllersForm() {
    this.terminalControllersFormGroup = this.formBuilder.group({
      controllerType: this.formBuilder.control(this.costReviewTerminalUnits.controllerType ?? []),
      numberOfTerminalUnits: this.formBuilder.control(this.costReviewTerminalUnits.numberOfTerminalUnits || 0),
      numberOfVavs: this.formBuilder.control(this.costReviewTerminalUnits.numberOfVavs || 0),
      manufacturerVavs: this.formBuilder.control(this.costReviewTerminalUnits.manufacturerVavs),
      customApplicationsRequired: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewTerminalUnits.customApplicationsRequired)),
      vavsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewTerminalUnits.vavsInstalledBy)),
      numberOfFcus: this.formBuilder.control(this.costReviewTerminalUnits.numberOfFcus || 0),
      manufacturerFcus: this.formBuilder.control(this.costReviewTerminalUnits.manufacturerFcus),
      fcusInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.FCU_INSTALLED_BY, this.costReviewTerminalUnits.fcusInstalledBy)),
      numberOfUvs: this.formBuilder.control(this.costReviewTerminalUnits.numberOfUvs || 0),
      manufacturerUvs: this.formBuilder.control(this.costReviewTerminalUnits.manufacturerUvs),
      unitsControlsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewTerminalUnits.unitsControlsFurnishedBy)),
      unitsControlsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewTerminalUnits.unitsControlsInstalledBy)),
      unitsControlsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewTerminalUnits.unitsControlsWiredBy)),
      power: this.formBuilder.control(this.getParameterValues(this.constants.POWERTRUNK_LOCALPOWER, this.costReviewTerminalUnits.power)),
      installingPneumaticTubing: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewTerminalUnits.installingPneumaticTubing))
    });
  }

  createLabEquipmentForm() {
    this.labEquipmentFormGroup = this.formBuilder.group({
      numberOfTerminalUnits: this.formBuilder.control(this.costReviewLabEquipment.numberOfTerminalUnits || 0),
      manufacturer: this.formBuilder.control(this.costReviewLabEquipment.manufacturer),
      airValvesFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewLabEquipment.airValvesFurnishedBy ?? Constants.TWO)),
      airValvesInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewLabEquipment.airValvesInstalledBy ?? Constants.TWO)),
      controlsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewLabEquipment.controlsFurnishedBy ?? Constants.TWO)),
      controlsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewLabEquipment.controlsInstalledBy ?? Constants.TWO)),
      controlsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewLabEquipment.controlsWiredBy ?? Constants.TWO)),
      networkType: this.formBuilder.control(this.getParameterValues(this.constants.ETHERNET_MSTP, this.costReviewLabEquipment.networkType ?? Constants.TWO)),
      power: this.formBuilder.control(this.getParameterValues(this.constants.POWERTRUNK_LOCALPOWER, this.costReviewLabEquipment.power ?? Constants.TWO))
    });
  }

  createVfdsForm() {
    this.vfdsFormGroup = this.formBuilder.group({
      numberOfVfds: this.formBuilder.control(this.costReviewVFDS.numberOfVfds || 0),
      manufacturer: this.formBuilder.control(this.costReviewVFDS.manufacturer),
      drivers: this.formBuilder.control(this.getParameterValues(this.constants.HARDWIRED_INTEGRATION, this.costReviewVFDS.drivers)),
      unitsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewVFDS.unitsFurnishedBy)),
      unitsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewVFDS.unitsInstalledBy)),
      unitsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewVFDS.unitsWiredBy))
    });
  }

  createControlValvesForm() {
    this.controlValvesFormGroup = this.formBuilder.group({
      numberOfValves: this.formBuilder.control(this.costReviewControlValves.numberOfValves || 0),
      manufacturer: this.formBuilder.control(this.costReviewControlValves.manufacturer),
      applications: this.formBuilder.control(this.costReviewControlValves.applications ?? []),
      unitsActuatorsFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewControlValves.unitsActuatorsFurnishedBy)),
      unitsActuatorsInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewControlValves.unitsActuatorsInstalledBy)),
      unitsActuatorsWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewControlValves.unitsActuatorsWiredBy))
    });
  }

  createAfmsForm() {
    this.afmssFormGroup = this.formBuilder.group({
      numberOfAfms: this.formBuilder.control(this.costReviewAfmss.numberOfAfms || 0),
      manufacturer: this.formBuilder.control(this.costReviewAfmss.manufacturer),
      applications: this.formBuilder.control(this.costReviewAfmss.applications ?? []),
      afmsSchedule: this.formBuilder.control(this.getParameterValues(this.constants.YES_NO, this.costReviewAfmss.afmsSchedule)),
      unitsDevicesFurnishedBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewAfmss.unitsDevicesFurnishedBy)),
      unitsDevicesInstalledBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewAfmss.unitsDevicesInstalledBy)),
      unitsDevicesWiredBy: this.formBuilder.control(this.getParameterValues(this.constants.SIEMENS_OTHER, this.costReviewAfmss.unitsDevicesWiredBy))
    });
  }


  getParameterValues(key: string, value: string | number | undefined): string {
    value ??= Constants.EMPTY_STRING;
    return this.reviewService.getCostReviewParametersDescription(key, value);
  }

  getParameterValuesForArray(key: string, value: Array<string | number> | undefined): string {
    if (!value || value.length === 0) {
      value = [Constants.EMPTY_STRING];
    }
    return this.reviewService.getCostReviewParametersDescriptionForArray(key, value);
  }

  getDropdownValues(key: string): { label: string; value: string }[] {
    return this.reviewService.getDropdownValues(key);
  }

  get driversBoilers(): string {
    return this.heatingPlantFormGroup?.get('driversBoilers')?.value || Constants.EMPTY_STRING;
  }

  get driversTowers(): string {
    return this.heatingPlantFormGroup?.get('driversTowers')?.value || Constants.EMPTY_STRING;
  }

  get driversPumps(): string {
    return this.heatingPlantFormGroup?.get('driversPumps')?.value || Constants.EMPTY_STRING;
  }
  get isExistingWiringReused() : boolean{
    return this.commonFunctionsService.isControlValueEqualToTranslation(this.retrofitConsiderationsFormGroup, 'existingWiringReused', 'YES');
  }
  get isPrefabControllerUsedYes(): boolean {
    const value = this.costReviewPreFab?.prefabControllerUsed;
    // Free-text field: accept the English constant as well as the current-culture translation.
    return value === this.constants.YES || this.commonFunctionsService.isValueEqualToTranslation(value, 'YES');
  }
  formControlsValueForString(formGroup: FormGroup | undefined, formControlName: string): string {
    return this.commonFunctionsService.formControlsValueForString(formGroup, formControlName);
  }

  formControlsValueForNumber(formGroupName: FormGroup, formControlName: string): number {
    const controlValue: number = formGroupName?.controls[formControlName]?.value;
    return controlValue || 0;  
  }

  setFormControlValue(formGroup: FormGroup | undefined, controlName: string, value: string | number): void {
    const control = formGroup?.get(controlName);
    if (!control || control.value === value) {
      return;
    }

    control.setValue(value);
  }

  private getParameterCode(parameter: string, description: string, currentValue: number | undefined): number {
    const code = this.reviewService.getCostReviewParametersCode(parameter, description);
    return code !== undefined ? code : (currentValue ?? 0);
  }

   private getReviewLibraryState(): void {
    this.isDisabled = this.reviewDetailsTabService.getReviewLibraryDisableFlag();
  }

  subscribeToNumberOfNodesChanges(): void {
    if(!this.systemConfigurationFormGroup) {
      return;
    }
      this.systemConfigurationFormGroup.get('numberOfNodes')?.valueChanges
        .pipe(
          startWith(this.systemConfigurationFormGroup.get('numberOfNodes')?.value),
          takeUntil(this.destroy$)
        )
        .subscribe((newValue: number | undefined) => {
          if((newValue ?? 0) <= 0) {
            this.systemConfigurationFormGroup.controls['networkStyle'].disable({ emitEvent: false });
            this.systemConfigurationFormGroup.controls['networkOptions'].disable({ emitEvent: false });
          }
          else {
            this.systemConfigurationFormGroup.controls['networkStyle'].enable({ emitEvent: false });
            this.systemConfigurationFormGroup.controls['networkOptions'].enable({ emitEvent: false });
          }
        });
  }

  private getDropdownOptions(prefix: string): Array<{ label: string; value: string }> {
    return [...this.reviewService.costReviewParameters]
      .filter(p => p.parameterID.startsWith(prefix) && p.description?.trim())
      .map(p => ({
        label: p.description,
        value: p.description
      }));
  }

  populateReasonForExceptionDropdown() {
      this.reasonsForExceptionDropDownData = this.getDropdownOptions('REASONFOREXCEPTION_PREFAB_');
  }
}
